import { render, staticRenderFns } from "./ForgotTranPassword.vue?vue&type=template&id=04fa6dd2&"
import script from "./ForgotTranPassword.vue?vue&type=script&lang=ts&"
export * from "./ForgotTranPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports